import { render, staticRenderFns } from "./FlebogrifPage.vue?vue&type=template&id=66f3ae67&scoped=true"
import script from "./FlebogrifPage.vue?vue&type=script&lang=js"
export * from "./FlebogrifPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f3ae67",
  null
  
)

export default component.exports